
/* @ngInject */
export default class ApplicationHelpController {
    constructor(onShowFeedbackForm, organizationId, ClipboardService) {
        this.onShowFeedbackForm = onShowFeedbackForm;
        this.organizationId = organizationId;
        this.ClipboardService = ClipboardService;
        
        // Configuration for custom support organizations
        this.customSupportConfigs = {
            'cqjvp7s0rgkc1lv58cv0': {
                supportEmail: 'QATeam@hbham.com',
                message: 'For support and assistance, please contact your dedicated support team.'
            }
        };
        
        // Check if this organization has custom support configuration
        this.customSupportConfig = this.customSupportConfigs[organizationId];
        this.isCustomSupportOrg = !!this.customSupportConfig;
    }

    showFeedbackForm() {
        this.onShowFeedbackForm();
    }

    copyEmailToClipboard() {
        if (this.customSupportConfig) {
            this.ClipboardService.copyStringToClipboard(this.customSupportConfig.supportEmail, 'Support Email');
        }
    }
}
